import { useOrgAssignment } from "@/hooks/useOrgAssignment";
import { Input, Label, Switch } from "@fluentui/react-components";
import { Search20Regular } from "@fluentui/react-icons";
import React from "react";
import { DualListBox } from "../DualListBox";
import { LoadingCover } from "../LoadingCover";
import styles from "./index.module.css";

export const OrgAssignmentDualListBox: React.FC<{
  assignment: ReturnType<typeof useOrgAssignment>;
  disabled?: boolean;
  rightHeaderLabel?: string;
  isSearchBoxAboveLists?: boolean;
  labelClassName?: string;
}> = ({
  assignment,
  disabled = false,
  rightHeaderLabel = "使用可能な組織",
  isSearchBoxAboveLists = false,
  labelClassName,
}) => {
  const {
    showAllOrgs,
    setShowAllOrgs,
    initialAssignedState,
    updatedAssignedState,
    filteredLeftOrgs,
    filterText,
    setFilterText,
    handleChange,
    isReady,
    isAllOrgsLoading,
  } = assignment;

  const searchBox = (
    <Input
      className={
        isSearchBoxAboveLists ? styles.searchBoxAboveLists : styles.searchBox
      }
      placeholder="組織名、IDで絞り込む"
      value={filterText}
      onChange={(_, data) => setFilterText(data.value)}
      disabled={disabled}
      contentBefore={<Search20Regular />}
      size="small"
    />
  );

  return (
    <div className={styles.section}>
      <Label className={labelClassName}>使用可能にする組織の設定</Label>
      <div className={styles.controls}>
        <Switch
          label="所属外の組織も表示"
          checked={showAllOrgs}
          onChange={(_, { checked }) => setShowAllOrgs(checked)}
        />
        {isSearchBoxAboveLists && searchBox}
      </div>
      {!isReady || isAllOrgsLoading ? (
        <LoadingCover />
      ) : (
        <DualListBox
          getKey={(item) => item.id}
          renderItem={(item) => (
            <div className={styles.orgItem}>
              <div className={styles.orgItemName}>{item.name}</div>
              <div className={styles.orgItemId}>{item.id}</div>
            </div>
          )}
          itemHeight={45}
          sort={(a, b) => a.name.localeCompare(b.name)}
          initialItems={initialAssignedState}
          items={updatedAssignedState}
          visibleItems={{
            left: filteredLeftOrgs,
            right: updatedAssignedState.right,
          }}
          onChange={handleChange}
          renderHeader={() => ({
            left: (
              <div className={styles.listHeader}>
                <span>候補</span>
                {!isSearchBoxAboveLists && searchBox}
              </div>
            ),
            right: (
              <div className={styles.listHeader}>
                <span>{rightHeaderLabel}</span>
                <span className={styles.listCount}>
                  {updatedAssignedState.right.length}件
                </span>
              </div>
            ),
          })}
          style={{ height: "450px" }}
          disabled={disabled}
        />
      )}
    </div>
  );
};
